'use strict';

var ConfigGroups = require('config/Groups');

/**
 * Collection of network configuration groups with custom sorting.
 * Extends the base ConfigGroups to add network-specific sorting logic
 * that ensures WAN ports always appear in consistent order (vlan1, vlan3, etc.)
 * regardless of modification time.
 */
module.exports = ConfigGroups.extend({
  /**
   * Comparator function to sort network groups in a consistent order.
   * Ensures WAN Port 1 (vlan1) always appears before WAN Port 2 (vlan3).
   *
   * @param {Backbone.Model} groupA - First group to compare
   * @param {Backbone.Model} groupB - Second group to compare
   * @return {Number} - Negative if groupA comes first, positive if groupB comes first, 0 for no change
   */
  comparator: function(groupA, groupB) {
    var typeA = groupA.get('type');
    var typeB = groupB.get('type');
    var typeIdA = groupA.get('typeId') || '';
    var typeIdB = groupB.get('typeId') || '';

    // Sort WAN groups (editWan) by their typeId
    if (typeA === 'editWan' && typeB === 'editWan') {
      return typeIdA.localeCompare(typeIdB);
    }

    return 0;
  },
});
